module.exports = __webpack_public_path__ + "img/user-12.3bca1fe5.svg";